import React, { useState } from "react";
import { db } from "../../modules/auth/firebaseConfig";
import {
  collection,
  addDoc,
  getDocs,
  query,
  where,
  serverTimestamp,
} from "firebase/firestore";

export default function SubscribePopup({ isOpen, onClose, source = "popup" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    setMessage("");

    try {
      // ✅ Check for duplicates
      const q = query(collection(db, "newsletterSubscribers"), where("email", "==", email));
      const existing = await getDocs(q);

      if (!existing.empty) {
        setMessage("⚠️ You’re already subscribed!");
        setTimeout(onClose, 1500);
        return;
      }

      // ✅ Save subscriber to Firestore
      await addDoc(collection(db, "newsletterSubscribers"), {
        email,
        createdAt: serverTimestamp(),
        source,
      });

      setMessage("✅ Thank you for subscribing!");
      setEmail("");

      // ✅ Auto-close after short delay
      setTimeout(onClose, 1500);

    } catch (err) {
      console.error("Subscription Error:", err);
      setMessage("❌ Error subscribing. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[9999] flex items-center justify-center"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative z-[10000] bg-white/95 backdrop-blur-xl border border-purple-100 shadow-2xl rounded-2xl w-[90%] max-w-md p-6 text-center animate-fadeIn"

      >
        {/* ✖ Close Button */}
        <button
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 text-lg"
          onClick={onClose}
        >
          ✕
        </button>

        {/* Header */}
        <h3 className="text-lg font-bold text-purple-600 mb-3">
          Subscribe to our Newsletter
        </h3>

        {/* Input + Button */}
        <form onSubmit={handleSubmit} className="flex flex-col items-center gap-3">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="Enter your email address"
            className="w-full px-4 py-2 rounded-full border border-gray-300 text-sm focus:outline-none focus:border-purple-500 text-black"
          />
          <button
            type="submit"
            disabled={loading}
            className="bg-gradient-to-r from-purple-500 to-blue-500 hover:from-purple-600 hover:to-blue-600 text-white px-6 py-2 rounded-full text-sm font-semibold transition w-full shadow-md"
          >
            {loading ? "Subscribing..." : "Subscribe"}
          </button>
        </form>

        {/* Message */}
        {message && (
          <p
            className={`text-xs mt-3 ${
              message.includes("Error")
                ? "text-red-500"
                : message.includes("⚠️")
                ? "text-yellow-500"
                : "text-green-600"
            }`}
          >
            {message}
          </p>
        )}
      </div>
    </div>
  );
}
